import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const SelectProductModalSkeleton = () => (
  <Box className={styles['table-skeleton__container']} border="1px solid var(--color-semantic-outline)">
    <Table className={styles['table__skeleton']}>
      <Thead>
        <Tr>
          <Th className={styles['skeleton__head']} width="42px">
            <SkeletonComponent height="18px" width="18px" />
          </Th>
          <Th className={styles['skeleton__head']} width="90px">
            <SkeletonComponent height="18px" width="80%" />
          </Th>
          <Th className={styles['skeleton__head']} width="300px">
            <SkeletonComponent height="18px" width="40%" />
          </Th>
          <Th className={styles['skeleton__head']} width="230px">
            <SkeletonComponent height="18px" width="50%" />
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Iteration
          items={[1, 2, 3, 4]}
          render={(num) => (
            <Tr key={num}>
              <Td className={styles['skeleton__column']}>
                <SkeletonComponent height="18px" width="18px" marginTop="16px" />
              </Td>
              <Td className={styles['skeleton__column']}>
                <SkeletonComponent height="46px" width="46px" borderRadius="4px" />
              </Td>
              <Td className={styles['skeleton__column']}>
                <Flex flexDirection="column" gap="4px">
                  <SkeletonComponent height="18px" width="80%" />
                  <SkeletonComponent height="18px" width="40%" />
                </Flex>
              </Td>
              <Td className={styles['skeleton__column']}>
                <Flex flexDirection="column" gap="4px">
                  <Flex gap="20px">
                    <SkeletonComponent height="18px" width="40%" />
                    <SkeletonComponent height="18px" width="40%" />
                  </Flex>
                  <Flex gap="20px">
                    <SkeletonComponent height="18px" width="40%" />
                    <SkeletonComponent height="18px" width="40%" />
                  </Flex>
                  <Flex gap="20px">
                    <SkeletonComponent height="18px" width="40%" />
                    <SkeletonComponent height="18px" width="40%" />
                  </Flex>
                </Flex>
              </Td>
            </Tr>
          )}
        />
      </Tbody>
    </Table>
  </Box>
);

export default SelectProductModalSkeleton;
